import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import steps from '../../../../components/steps/steps'
import backBtn from '../../../../components/backButton/backButton'
import tabs from '../../../../components/tabs/tabs'
import noData from '../../../../components/noData/noData'
import selectionBox from '../../../../components/selectionBox/selectionBox'
import contentBlock from '../../../../components/contentBlock/contentBlock'
import * as requiredUrls from '../../../../utils/appointment.url'
export default {
    data: function () {
        return {
            tabsList: [],
            value: '',
            tabTerm: '',
            options: [],
            companyList: [],
            serviceList: [],
            dialogTableVisible: true,
            areaSeq: this.$route.query.areaSeq,
            hallSeq: this.$route.query.hallSeq, 
            extentedType: this.$route.query.extentedType,//用于筛选小屋单位和服务类型          
        }
    },
    components: {
        BreadCrumb,
        steps,
        tabs,
        selectionBox,
        backBtn,
        noData,
        contentBlock
      },
    methods: {
        clickTab (term) {
            this.tabTerm = term.id;
            console.log(term);
            if (this.tabTerm == 1) {
                this.getCompanyList();
            } else {
                this.getServiceTypeList();
            } 
        },
        // 选择单位
        clickContentBlock (t, i) {
            console.log(t);
            this.$router.push({
                path: '/selectBusinessCurrency',
                query: {
                  areaSeq: this.$route.query.areaSeq,
                  unitSeq: t.seq,
                  hallName: this.$route.query.hallName,
                  extentedType:this.extentedType,
                  hallSeq:this.$route.query.hallSeq
                }
              })   
        },
        clickServiceList (t, i) {
            if (t.service == 1 && t.mbUrl) {
                window.open(t.mbUrl);
            } else {
                this.$router.push({
                    path: '/selectBusinessCurrency',
                    query: {
                      areaSeq: this.$route.query.areaSeq,
                      serTypeSeq: t.seq,
                      hallName: this.$route.query.hallName,
                      hallSeq:this.$route.query.hallSeq
                    }
                })
            }
        },
        // 获取单位列表数据
        getCompanyList (areaSeq) {
            requiredUrls.getUnitList({
                areaSeq: areaSeq,
                hallSeq: this.hallSeq,
                extentedType: this.extentedType,
              },
              'get'
        ).then(res => {
              if (res.status == '200') {
                console.log(res.data)
                this.companyList = res.data;
              } else {
                this.$message.error(res.desc)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        // 获取服务类型列表数据
        getServiceTypeList () {
            requiredUrls.getServiceTypeList({
                hallSeq: this.hallSeq
              },
              'get'
        ).then(res => {
              if (res.status == '200') {
                console.log(res.data)
                this.serviceList = res.data.list;
              } else {
                this.$message.error(res.desc)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        // 下拉框数据处理
        cascaderData () {
            requiredUrls.getScreeningTree2({
                areaSeq: this.areaSeq
              },
              'get'
        ).then(res => {
              if (res.status == '200') {
                this.options = [];  
                for (let i = 0; i < res.data.length; i++) {
                    let obj1 = {};
                    obj1.label = res.data[i].name;
                    obj1.value = res.data[i].seq;                    
                    if (res.data[i].hasOwnProperty('children')) {
                        obj1.children = [];
                        for (let j = 0; j < res.data[i].children.length; j++) {
                            let obj2 = {};
                            obj2.label = res.data[i].children[j].name;
                            obj2.value = res.data[i].children[j].seq;                            
                            if (res.data[i].children[j].hasOwnProperty('children')) {
                                obj2.children = [];
                                for (let z = 0; z < res.data[i].children[j].children.length; z++) {
                                    let obj3 = {};
                                    obj3.label = res.data[i].children[j].children[z].name;
                                    obj3.value = res.data[i].children[j].children[z].seq;                            
                                    obj2.children.push(obj3);
                                }
                                
                            }                            
                            obj1.children.push(obj2);
                        }                        
                    }
                    this.options.push(obj1);                    
                }
                console.log(this.options);
              } else {
                this.$message.error(res.desc)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        // 级联选择器选中处理
        changeCascader (value) {
            console.log(value);
            console.log(this.value[this.value.length-1]);
            this.getCompanyList(this.value[this.value.length-1]);
        },
        // 切换列表数据处理
        tabsListDandle (initialList) {
            let arr = [];
            for (let i = 0;  i < initialList.length; i++) {
                if (initialList[i] == 0) {
                    arr.push({
                        value: '单位',
                        id: 0
                    })
                } else if (initialList[i] == 1 && this.extentedType != 1) { //政务晓屋隐藏‘服务类型’
                    arr.push({
                        value: '服务类型',
                        id: 1
                    })
                } else {
                    
                }
            }
            console.log('arr',arr)
            return arr
        }
    },
    mounted () {
       // 初始化切换栏
       this.tabsList = this.tabsListDandle(this.$route.query.workMode.split(','));
       this.tabTerm = this.tabsList[0].id;
       console.log(this.tabsList);
       
       // 初始化数据
       this.getCompanyList();
       this.getServiceTypeList();
       this.cascaderData();
    },  
}
